import {
  loadInstallmentFees,
  saveInstallmentFees,
  validateInstallmentFees,
  validateCardFee,
} from '@/helpers/installmentFees';
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useDialog } from '@/hooks/useDialog';
import Contractor from '@/model/Contractor';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import {
  ContractorResponse,
  ContractorRequestParams,
  BanckAccountForm,
  FormInputNamePix,
  FormInputNameFee,
  FormInputTaxes,
} from '@/features/contractor/types';
import useForm from '@/hooks/useForm';
import {
  States,
  ContractorContainer,
  ShouldShowModal,
} from '@/features/contractor/screens/List/ui';
import validators from '@/helpers/validators';
import {
  updateMask as updateMaskCPFOrCNPJ,
  unmask as unMaskCPFOrCNPJ,
} from '@/helpers/masks/cpfCnpj';
import { updateMask as updateMaskCEP, unmask as unMaskCEP } from '@/helpers/masks/cep';
import {
  updateMask as updateMaskMobilePhone,
  unmask as unMaskMobilePhone,
} from '@/helpers/masks/mobilePhone';
import { unmask, updateMask as updateMaskCash } from '@/helpers/masks/cashNumber';
import { FormInputName as FormInputNameToSaveContractor } from '@/features/contractor/components/RegisterContent';
import { useConfirmDelete } from '@/hooks/useConfirmDelete';
import { FormInputName as FormInputNameToFilter } from '@/features/contractor/components/FilterContent';
import { colors } from '@/styles/colors';
import StatusType from '@/model/StatusType';
import { convertToBoolean } from '@/helpers/common/convertToBoolean';
// import ContractorType from '@/model/ContractorType';
import Bank from '@/model/Bank';
import PixType from '@/model/PixType';
import User from '@/model/User';
import Address from '@/model/Address';
import { DeleteContent } from '@/features/contractor/components/DeleteContent';
import Pix from '@/model/Pix';
import CompanyParameter from '@/model/CompanyParameter';
import CardFees from '@/model/CardFees';
import { EventProducer } from '@/model/EventProducer';

export default interface PayloadContractor {
  id?: string;
  name: string;
  document: string;
  telephone: string;
  email: string;
  reportPassword: string;
  reversePassword: string;
  bleedPassword: string;
  closeCashierPassword: string;
  courtesyPassword: string;
  reprintPassword: string;
  validatorPassword: string;
  pdvReportPassword: string;
  stockPassword: string;
  address?: Address;
  contractorType?: {
    id?: string;
  };
  bankAccount: {
    id?: string;
    contractorId?: string;
    agency: string;
    account: string;
    digit: string;
    bank: {
      id: string;
    };
  }[];
  pixKey: {
    id?: string;
    contractorId?: string;
    key: string;
    pixKeyType: PixType;
    bank: {
      id: string;
    };
  }[];
}

export const ContractorScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const [listContractor, setListContractor] = useState<Contractor[]>([]);
  // const [listContractorType, setListContractorType] = useState<ContractorType[]>([]);
  const [banks, setBanks] = useState<Bank[]>([]);
  const [listBankAccount, setListBankAccount] = useState<BanckAccountForm[]>([]);
  const [pixs, setPixs] = useState<Pix[]>([]);
  const [listUsers, setListUsers] = useState<User[]>([]);
  const [listUsersDefault, setListUsersDefault] = useState<User[]>([]);
  const [usersSelected, setUsersSelected] = useState<User[]>([]);
  const [bankAccount, setBankAccount] = useState<BanckAccountForm[]>([]);

  const [contractor, setContractor] = useState<Contractor>();
  const [toggleReportPassword, setToggleReportPassword] = useState<boolean>(false);
  const [toggleReversePassword, setToggleReversePassword] = useState<boolean>(false);
  const [toggleBleedPassword, setToggleBleedPassword] = useState<boolean>(false);
  const [toggleCloseCashierPassword, setToggleCloseCashierPassword] = useState<boolean>(false);
  const [toggleCourtesyPassword, setToggleCourtesyPassword] = useState<boolean>(false);
  const [toggleReprintPassword, setToggleReprintPassword] = useState<boolean>(false);
  const [toggleValidatorPassword, setToggleValidatorPassword] = useState<boolean>(false);
  const [togglePdvReportPassword, setTogglePdvReportPassword] = useState<boolean>(false);
  const [toggleStockPassword, setToggleStockPassword] = useState<boolean>(false);
  const [shouldShowModal, setShouldShowModal] = useState<ShouldShowModal>(
    ShouldShowModal.registerContractor,
  );
  const [currentPage, setCurrentPage] = useState<ContractorRequestParams>({
    page: 1,
    pageSize: 10,
    sort: 'name',
    order: 'DESC',
    total: 1,
  });

  const { title, visible, onChangeTitle, onToggle } = useDialog();
  const confirmDelete = useConfirmDelete();

  const {
    formData: formDataContractor,
    formErrors: formErrorsContractor,
    onChangeFormInput: onChangeFormInputContractor,
    isFormValid: isFormValidContractor,
    resetForm: resetFormContractor,
  } = useForm({
    initialData: {
      name: '',
      document: '',
      companyType: '',
      telephone: '',
      email: '',
      reportPassword: '',
      reversePassword: '',
      bleedPassword: '',
      closeCashierPassword: '',
      courtesyPassword: '',
      reprintPassword: '',
      validatorPassword: '',
      pdvReportPassword: '',
      stockPassword: '',
      zipCode: '',
      state: '',
      city: '',
      district: '',
      street: '',
      number: '',
      complement: '',
      latitude: '',
      longitude: '',
      pix: '',
      status: '',
      user: '',
    },
    validators: {
      name: [validators.required],
      document: [validators.required, validators.cpforcnpj],
      // zipCode: [validators.required, validators.cep],
      // state: [validators.required],
      // city: [validators.required],
      // district: [validators.required],
      // street: [validators.required],
      // number: [validators.required],
      telephone: [validators.required, validators.mobilePhone],
      email: [validators.required, validators.email],
      reportPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      reversePassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      bleedPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      closeCashierPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      courtesyPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      reprintPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      validatorPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      pdvReportPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
      stockPassword: [validators.required, validators.hasPasswordOnlyNumberCharacteres],
    },
    formatters: {
      document: updateMaskCPFOrCNPJ,
      telephone: updateMaskMobilePhone,
      zipCode: updateMaskCEP,
    },
  });

  const {
    formData: formDataPix,
    formErrors: formErrorsPix,
    onChangeFormInput: onChangeFormInputPix,
    isFormValid: isFormValidPix,
    resetForm: resetFormPix,
  } = useForm({
    initialData: {
      id: '',
      key: '',
      pixKeyType: '',
      bankId: '',
      recipient: '',
    },
    validators: {
      key: [validators.required],
      pixKeyType: [validators.required],
      bankId: [validators.required],
      recipient: [validators.required],
    },
  });

  const {
    formData: formDataFilter,
    formErrors: formErrorsFilter,
    onChangeFormInput: onChangeFormInputFilter,
    isFormValid: isFormValidFilter,
    resetForm: resetFormFilter,
  } = useForm({
    initialData: {
      filterSearch: '',
      inputSearch: '',
    },
  });

  const {
    formData: formDataFee,
    formErrors: formErrorsFee,
    onChangeFormInput: onChangeFormInputFee,
    isFormValid: isFormValidFee,
    resetForm: resetFormFee,
  } = useForm({
    initialData: {
      ticketPhysicalSaleId: '',
      ticketPhysicalSaleDebit: '',
      ticketPhysicalSaleCredit: '',
      ticketPhysicalSalePix: '',
      ticketPhysicalSaleAdministrateTax: '',
      ticketPhysicalSaleInstallmentFees: '[]',

      ticketWebsiteSaleId: '',
      ticketWebsiteSaleBankSlip: '',
      ticketWebsiteSaleCredit: '',
      ticketWebsiteSalePix: '',
      ticketWebsiteSaleAdministrateTax: '',
      ticketWebsiteSaleInstallmentFees: '[]',

      productPhysicalSaleId: '',
      productPhysicalSaleDebit: '',
      productPhysicalSaleCredit: '',
      productPhysicalSalePix: '',
      productPhysicalSaleAdministrateTax: '',
      productPhysicalSaleInstallmentFees: '[]',

      productWebsiteSaleId: '',
      productWebsiteSaleBankSlip: '',
      productWebsiteSaleCredit: '',
      productWebsiteSalePix: '',
      productWebsiteSaleAdministrateTax: '',
      productWebsiteSaleInstallmentFees: '[]',
    },
    validators: {
      ticketPhysicalSaleDebit: [validateCardFee],
      ticketPhysicalSaleCredit: [validateCardFee],
      ticketPhysicalSalePix: [validateCardFee],
      ticketPhysicalSaleAdministrateTax: [validateCardFee],
      ticketPhysicalSaleInstallmentFees: [validateInstallmentFees],

      ticketWebsiteSaleBankSlip: [validateCardFee],
      ticketWebsiteSaleCredit: [validateCardFee],
      ticketWebsiteSalePix: [validateCardFee],
      ticketWebsiteSaleAdministrateTax: [validateCardFee],
      ticketWebsiteSaleInstallmentFees: [validateInstallmentFees],

      productPhysicalSaleDebit: [validateCardFee],
      productPhysicalSaleCredit: [validateCardFee],
      productPhysicalSalePix: [validateCardFee],
      productPhysicalSaleAdministrateTax: [validateCardFee],
      productPhysicalSaleInstallmentFees: [validateInstallmentFees],

      productWebsiteSaleBankSlip: [validateCardFee],
      productWebsiteSaleCredit: [validateCardFee],
      productWebsiteSalePix: [validateCardFee],
      productWebsiteSaleAdministrateTax: [validateCardFee],
      productWebsiteSaleInstallmentFees: [validateInstallmentFees],
    },
    formatters: {
      ticketPhysicalSaleDebit: updateMaskCash,
      ticketPhysicalSaleCredit: updateMaskCash,
      ticketPhysicalSalePix: updateMaskCash,
      ticketPhysicalSaleAdministrateTax: updateMaskCash,

      ticketWebsiteSaleBankSlip: updateMaskCash,
      ticketWebsiteSaleCredit: updateMaskCash,
      ticketWebsiteSalePix: updateMaskCash,
      ticketWebsiteSaleAdministrateTax: updateMaskCash,

      productPhysicalSaleDebit: updateMaskCash,
      productPhysicalSaleCredit: updateMaskCash,
      productPhysicalSalePix: updateMaskCash,
      productPhysicalSaleAdministrateTax: updateMaskCash,

      productWebsiteSaleBankSlip: updateMaskCash,
      productWebsiteSaleCredit: updateMaskCash,
      productWebsiteSalePix: updateMaskCash,
      productWebsiteSaleAdministrateTax: updateMaskCash,
    },
  });

  const {
    formData: formDataTaxes,
    formErrors: formErrorsTaxes,
    onChangeFormInput: onChangeFormInputTaxes,
    isFormValid: isFormValidTaxes,
    resetForm: resetFormTaxes,
  } = useForm({
    initialData: {
      calcAdmFee: 'false',
      pdv: '',
      generalCommission: 'true',
      credit: '',
      installment: '',
      debit: '',
      pix: '',
      bankslip: '',
      food: '',
      technical: '',
      trip: '',
      rentPos: '',
      courtesyIssuance: '',
      cashSaleDashboard: '',
      ticketCancellations: '',
      blockMap: '',
      releaseMap: '',
      ticketRoll: '',
      calcAdmFeeProduct: 'false',
      pdvProduct: '',
      generalCommissionProduct: 'true',
      creditProduct: '',
      installmentProduct: '',
      debitProduct: '',
      pixProduct: '',
      bankSlipProduct: '',
      foodProduct: '',
      technicalProduct: '',
      tripProduct: '',
      rentPosProduct: '',
      courtesyIssuanceProduct: '',
      cashSaleDashboardProduct: '',
      ticketCancellationsProduct: '',
      ticketRollProduct: '',
    },
    validators: {
      calcAdmFee: [validators.required],
      pdv: [validators.required],
      generalCommission: [validators.required],
      credit: [validators.required],
      installment: [validators.required],
      debit: [validators.required],
      pix: [validators.required],
      bankslip: [validators.required],
      food: [validators.required],
      technical: [validators.required],
      trip: [validators.required],
      rentPos: [validators.required],
      courtesyIssuance: [validators.required],
      cashSaleDashboard: [validators.required],
      ticketCancellations: [validators.required],
      blockMap: [validators.required],
      releaseMap: [validators.required],
      ticketRoll: [validators.required],
      calcAdmFeeProduct: [validators.required],
      pdvProduct: [validators.required],
      generalCommissionProduct: [validators.required],
      creditProduct: [validators.required],
      installmentProduct: [validators.required],
      debitProduct: [validators.required],
      pixProduct: [validators.required],
      bankSlipProduct: [validators.required],
      foodProduct: [validators.required],
      technicalProduct: [validators.required],
      tripProduct: [validators.required],
      rentPosProduct: [validators.required],
      courtesyIssuanceProduct: [validators.required],
      cashSaleDashboardProduct: [validators.required],
      ticketCancellationsProduct: [validators.required],
      ticketRollProduct: [validators.required],
    },
    formatters: {
      pdv: updateMaskCash,
      credit: updateMaskCash,
      installment: updateMaskCash,
      debit: updateMaskCash,
      pix: updateMaskCash,
      bankslip: updateMaskCash,
      food: updateMaskCash,
      technical: updateMaskCash,
      trip: updateMaskCash,
      rentPos: updateMaskCash,
      courtesyIssuance: updateMaskCash,
      cashSaleDashboard: updateMaskCash,
      ticketCancellations: updateMaskCash,
      blockMap: updateMaskCash,
      releaseMap: updateMaskCash,
      ticketRoll: updateMaskCash,
      pdvProduct: updateMaskCash,
      creditProduct: updateMaskCash,
      installmentProduct: updateMaskCash,
      debitProduct: updateMaskCash,
      pixProduct: updateMaskCash,
      bankSlipProduct: updateMaskCash,
      foodProduct: updateMaskCash,
      technicalProduct: updateMaskCash,
      tripProduct: updateMaskCash,
      rentPosProduct: updateMaskCash,
      courtesyIssuanceProduct: updateMaskCash,
      cashSaleDashboardProduct: updateMaskCash,
      ticketCancellationsProduct: updateMaskCash,
      ticketRollProduct: updateMaskCash,
    },
  });

  useEffect(() => {
    if (!visible) {
      setTimeout(() => {
        resetFormContractor();
        setListBankAccount([]);
        setPixs([]);
        setUsersSelected([]);
        setContractor(undefined);
      }, 500);
    }
  }, [visible]);

  const controllerInputAppendBankAccount = {
    banks,
    bankAccount,
    setBankAccount,
    handleAddBanckAccount(): void {
      setBankAccount([
        ...bankAccount,
        {
          id: '',
          name: '',
          agencia: '',
          conta: '',
        },
      ]);
    },
    handleChangeBanckAccount(inputName: string, index: number, value: string): void {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const newFormValues = [...bankAccount] as any;
      newFormValues[index][inputName] = value;
      setBankAccount(newFormValues);
    },
    handleRemoveBanckAccount(index: number): void {
      const values = [...bankAccount];
      values.splice(index, 1);
      setBankAccount(values);
    },
  };

  const handleOnRemovePix = (index: number): void => {
    const values = [...pixs];
    values.splice(index, 1);
    setPixs(values);
  };

  /*
  const handleGetUsers = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<User[]>('/user/find');

      if (data) {
        setListUsers(data);
        setListUsersDefault(data);
        setUsersSelected([]);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };
  */

  const handleGetUsers = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<User[]>('/user/find');

      if (data) {
        setListUsers(data);
        setListUsersDefault(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const controllerAppendUser = {
    listUsers,
    usersSelected,
    handleAddUser(userId: string): void {
      const newUsersSelected = listUsers.filter(item => item.id === userId)[0];
      // not add user if already exists
      if (usersSelected.find(item => item.id === newUsersSelected.id)) {
        return;
      }
      setUsersSelected([...usersSelected, newUsersSelected]);
      // remove user selected from list
      const newListUsers = listUsers.filter(item => item.id !== userId);
      setListUsers(newListUsers);
    },
    handleRemoveUser(index: number): void {
      const values = [...usersSelected];
      values.splice(index, 1);
      setUsersSelected(values);
      // add user removed to list
      const newUser = listUsers.concat(usersSelected[index]);
      setListUsers(newUser);
    },
    handleGetUsers,
  };

  const handleGetbankAccount = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<Bank[]>('/bank/find');

      if (data) {
        setBanks(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  /*
  const handleGetContractorType = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.post<ContractorResponse>('/contractor/type/page', {});

      if (data) {
        setListContractorType(data?.list ?? []);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };
  */

  const handleFetch = async (values: ContractorRequestParams): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.post<ContractorResponse>('/contractor/page', values);

      if (data) {
        setListContractor(data?.list ?? []);

        setCurrentPage(currentPageState => ({
          ...currentPageState,
          ...data,
        }));
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };
  const handleOnChangeColorColumn = (status: StatusType): string =>
    ({
      0: colors.green,
      1: colors.red,
      2: colors.red,
    }[status] || colors.grey);

  const handleOnLoadPix = (index: number): void => {
    if (index > -1) {
      if (pixs && pixs.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < pixs.length; i++) {
          if (i === index) {
            onChangeFormInputPix(FormInputNamePix.id)(pixs[i].id);
            onChangeFormInputPix(FormInputNamePix.key)(pixs[i].key);
            onChangeFormInputPix(FormInputNamePix.pixKeyType)(`${pixs[i].pixKeyType}`);
            onChangeFormInputPix(FormInputNamePix.bankId)(pixs[i].bank.id);
            onChangeFormInputPix(FormInputNamePix.recipient)(
              pixs[i].recipient ? pixs[i].recipient : '',
            );
            break;
          }
        }
      }
    }
  };

  const handleOnShouldShowModal = ({
    value,
    newTitleModal,
    contractor: companySelected,
    pixIndex,
    isEdit,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    contractor?: Contractor;
    pixIndex?: number;
    isEdit?: boolean;
  }): void => {
    setShouldShowModal(value);
    onChangeTitle(newTitleModal);

    // reset list users
    setListUsers(listUsersDefault);

    if (value !== ShouldShowModal.filter) {
      if (
        value === ShouldShowModal.registerPix &&
        pixIndex !== undefined &&
        pixIndex !== null &&
        companySelected
      ) {
        handleOnLoadPix(pixIndex);
      } else if (!isEdit) {
        setBankAccount([...listBankAccount, { id: '', name: '', agencia: '', conta: '' }]);
      } else {
        setBankAccount([...listBankAccount]);
        setPixs([...pixs]);
      }
    }

    if (
      (companySelected?.id && value !== ShouldShowModal.filter) ||
      (!companySelected?.id && value !== ShouldShowModal.filter)
    ) {
      setContractor(companySelected);
      setListUsers(() => {
        // remove users selected from list listUsersDefault
        const newListUsers = listUsersDefault.filter(
          item => !usersSelected?.find(user => user.id === item.id),
        );
        return newListUsers;
      });
    }
  };

  const handleOnSaveContractor = async (): Promise<void> => {
    try {
      if (isFormValidContractor()) {
        const activedInput = convertToBoolean(
          formDataContractor[FormInputNameToSaveContractor.status],
        );
        const dataBankAccount = listBankAccount.map(bank => ({
          contractorId: contractor?.id,
          agency: bank.agencia,
          account: bank.conta.split('-')[0],
          digit: bank.conta.split('-')[1],
          bank: {
            id: bank.id,
          },
        }));

        const dataUsers = usersSelected.map(item => item.id);

        const payload: PayloadContractor = {
          id: contractor?.id,
          name: formDataContractor[FormInputNameToSaveContractor.name],
          document: unMaskCPFOrCNPJ(formDataContractor[FormInputNameToSaveContractor.document]),
          telephone: unMaskMobilePhone(formDataContractor[FormInputNameToSaveContractor.telephone]),
          email: formDataContractor[FormInputNameToSaveContractor.email],
          reportPassword: formDataContractor[FormInputNameToSaveContractor.reportPassword],
          reversePassword: formDataContractor[FormInputNameToSaveContractor.reversePassword],
          bleedPassword: formDataContractor[FormInputNameToSaveContractor.bleedPassword],
          closeCashierPassword:
            formDataContractor[FormInputNameToSaveContractor.closeCashierPassword],
          courtesyPassword: formDataContractor[FormInputNameToSaveContractor.courtesyPassword],
          reprintPassword: formDataContractor[FormInputNameToSaveContractor.reprintPassword],
          validatorPassword: formDataContractor[FormInputNameToSaveContractor.validatorPassword],
          pdvReportPassword: formDataContractor[FormInputNameToSaveContractor.pdvReportPassword],
          stockPassword: formDataContractor[FormInputNameToSaveContractor.stockPassword],
          /*
          address: {
            id: contractor?.address?.id,
            zipCode: unMaskCEP(formDataContractor[FormInputNameToSaveContractor.zipCode]),
            state: formDataContractor[FormInputNameToSaveContractor.state],
            city: formDataContractor[FormInputNameToSaveContractor.city],
            district: formDataContractor[FormInputNameToSaveContractor.district],
            street: formDataContractor[FormInputNameToSaveContractor.street],
            complement: formDataContractor[FormInputNameToSaveContractor.complement],
            number: formDataContractor[FormInputNameToSaveContractor.number],
            latitude: parseFloat(formDataContractor[FormInputNameToSaveContractor.latitude]) || 0.0,
            longitude:
              parseFloat(formDataContractor[FormInputNameToSaveContractor.longitude]) || 0.0,
          },
          */
          contractorType: {
            id: formDataContractor[FormInputNameToSaveContractor.companyType],
          },
          bankAccount: dataBankAccount,
          pixKey: pixs,
        };
        if (formDataContractor[FormInputNameToSaveContractor.zipCode] || contractor?.address?.id) {
          const address: Address = {
            id: contractor?.address?.id,
            zipCode: unMaskCEP(formDataContractor[FormInputNameToSaveContractor.zipCode]),
            state: formDataContractor[FormInputNameToSaveContractor.state],
            city: formDataContractor[FormInputNameToSaveContractor.city],
            district: formDataContractor[FormInputNameToSaveContractor.district],
            street: formDataContractor[FormInputNameToSaveContractor.street],
            complement: formDataContractor[FormInputNameToSaveContractor.complement],
            number: formDataContractor[FormInputNameToSaveContractor.number],
            latitude:
              parseFloat(formDataContractor[FormInputNameToSaveContractor.latitude]) || undefined,
            longitude:
              parseFloat(formDataContractor[FormInputNameToSaveContractor.longitude]) || undefined,
          };
          payload.address = address;
        }

        if (payload.contractorType?.id === 'empty' || payload.contractorType?.id === 'undefined') {
          delete payload.contractorType;
        }

        if (!payload.id) {
          delete payload.id;

          setState(States.loading);
          const { data: dataContractor } = await api.post<Contractor>('/contractor', payload);

          await api.post('/contractor/user', {
            contractorId: dataContractor.id,
            users: dataUsers,
          });

          await api.patch<Contractor>(
            `/contractor${activedInput ? '/activate' : '/inactivate'}/${dataContractor.id}`,
          );
          toast.success('Empresa cadastrada com sucesso!');
        } else {
          setState(States.loading);
          await api.put<Contractor>('/contractor', payload);

          await api.patch<Contractor>(
            `/contractor${activedInput ? '/activate' : '/inactivate'}/${contractor?.id}`,
          );

          await api.post('/contractor/user', {
            contractorId: contractor?.id,
            users: dataUsers,
          });
          toast.success('Empresa atualizada com sucesso!');
        }

        onToggle();
        handleFetch(currentPage);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleOnBankAccount = async (): Promise<void> => {
    try {
      // verify if the bank account not exists values empty
      const bankAccountEmpty = bankAccount.find(
        item => item.id === '' || item.name === '' || item.agencia === '' || item.conta === '',
      );
      if (bankAccountEmpty) {
        toast.warn('Preencha todos os campos ou remova a conta bancária que contém campos vazios');
        return;
      }
      setListBankAccount(bankAccount);
      handleOnShouldShowModal({
        value: ShouldShowModal.registerContractor,
        newTitleModal: contractor?.id ? contractor.name : 'Cadastrar nova empresa (contratante)',
        contractor,
      });
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    }
  };

  const handleOnPix = async (): Promise<void> => {
    if (isFormValidPix()) {
      const newPixs: Pix[] = [];
      let found = false;
      if (pixs && pixs.length > 0) {
        pixs.forEach(data => {
          if (formDataPix[FormInputNamePix.id] && formDataPix[FormInputNamePix.id] === data.id) {
            const newPix = {
              id: formDataPix[FormInputNamePix.id],
              contractorId: data.contractorId,
              key: formDataPix[FormInputNamePix.key],
              pixKeyType: Number(formDataPix[FormInputNamePix.pixKeyType]),
              bank: { id: formDataPix[FormInputNamePix.bankId] } as Bank,
              recipient: formDataPix[FormInputNamePix.recipient],
            };
            newPixs.push(newPix);
            found = true;
          } else {
            newPixs.push(data);
          }
        });
      }
      if (!found) {
        const newPix = {
          id: formDataPix[FormInputNamePix.id],
          key: formDataPix[FormInputNamePix.key],
          pixKeyType: Number(formDataPix[FormInputNamePix.pixKeyType]),
          bank: { id: formDataPix[FormInputNamePix.bankId] } as Bank,
          recipient: formDataPix[FormInputNamePix.recipient],
        } as Pix;
        newPixs.push(newPix);
      }
      resetFormPix();
      setPixs(newPixs);
      handleOnShouldShowModal({
        value: ShouldShowModal.registerContractor,
        newTitleModal: contractor?.id ? contractor.name : 'Cadastrar nova empresa (contratante)',
        contractor,
      });
    }
  };

  const handleOnClose = (): void => confirmDelete.hide();

  const handleOnConfirmDeleteToContractor = async (posSelected: Contractor): Promise<void> => {
    try {
      await api.delete(`/contractor/${posSelected?.id}`);

      toast.success('empresa excluída com sucesso!');
      handleOnClose();
      handleFetch(currentPage);
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    }
  };

  const mountTicketPhysicalSale = (): CardFees => {
    const physicalSale = {
      debit: +unmask(formDataFee[FormInputNameFee.ticketPhysicalSaleDebit]),
      credit: +unmask(formDataFee[FormInputNameFee.ticketPhysicalSaleCredit]),
      pix: +unmask(formDataFee[FormInputNameFee.ticketPhysicalSalePix]),
      administrateTax: +unmask(formDataFee[FormInputNameFee.ticketPhysicalSaleAdministrateTax]),
      installmentFees: saveInstallmentFees(
        formDataFee[FormInputNameFee.ticketPhysicalSaleInstallmentFees],
      ),
    } as CardFees;
    if (
      formDataFee[FormInputNameFee.ticketPhysicalSaleId] &&
      formDataFee[FormInputNameFee.ticketPhysicalSaleId].trim().length > 0
    ) {
      physicalSale.id = formDataFee[FormInputNameFee.ticketPhysicalSaleId];
    }
    return physicalSale;
  };

  const mountTicketWebsiteSale = (): CardFees => {
    const websiteSale = {
      credit: +unmask(formDataFee[FormInputNameFee.ticketWebsiteSaleCredit]),
      bankSlip: +unmask(formDataFee[FormInputNameFee.ticketWebsiteSaleBankSlip]),
      pix: +unmask(formDataFee[FormInputNameFee.ticketWebsiteSalePix]),
      administrateTax: +unmask(formDataFee[FormInputNameFee.ticketWebsiteSaleAdministrateTax]),
      installmentFees: saveInstallmentFees(
        formDataFee[FormInputNameFee.ticketWebsiteSaleInstallmentFees],
      ),
    } as CardFees;
    if (
      formDataFee[FormInputNameFee.ticketWebsiteSaleId] &&
      formDataFee[FormInputNameFee.ticketWebsiteSaleId].trim().length > 0
    ) {
      websiteSale.id = formDataFee[FormInputNameFee.ticketWebsiteSaleId];
    }
    return websiteSale;
  };

  const mountProductPhysicalSale = (): CardFees => {
    const physicalSale = {
      debit: +unmask(formDataFee[FormInputNameFee.productPhysicalSaleDebit]),
      credit: +unmask(formDataFee[FormInputNameFee.productPhysicalSaleCredit]),
      pix: +unmask(formDataFee[FormInputNameFee.productPhysicalSalePix]),
      administrateTax: +unmask(formDataFee[FormInputNameFee.productPhysicalSaleAdministrateTax]),
      installmentFees: saveInstallmentFees(
        formDataFee[FormInputNameFee.productPhysicalSaleInstallmentFees],
      ),
    } as CardFees;
    if (
      formDataFee[FormInputNameFee.productPhysicalSaleId] &&
      formDataFee[FormInputNameFee.productPhysicalSaleId].trim().length > 0
    ) {
      physicalSale.id = formDataFee[FormInputNameFee.productPhysicalSaleId];
    }
    return physicalSale;
  };

  const mountProductWebsiteSale = (): CardFees => {
    const websiteSale = {
      credit: +unmask(formDataFee[FormInputNameFee.productWebsiteSaleCredit]),
      bankSlip: +unmask(formDataFee[FormInputNameFee.productWebsiteSaleBankSlip]),
      pix: +unmask(formDataFee[FormInputNameFee.productWebsiteSalePix]),
      administrateTax: +unmask(formDataFee[FormInputNameFee.productWebsiteSaleAdministrateTax]),
      installmentFees: saveInstallmentFees(
        formDataFee[FormInputNameFee.productWebsiteSaleInstallmentFees],
      ),
    } as CardFees;
    if (
      formDataFee[FormInputNameFee.productWebsiteSaleId] &&
      formDataFee[FormInputNameFee.productWebsiteSaleId].trim().length > 0
    ) {
      websiteSale.id = formDataFee[FormInputNameFee.productWebsiteSaleId];
    }
    return websiteSale;
  };

  const handleOnSaveFee = async (): Promise<void> => {
    if (isFormValidFee()) {
      try {
        setState(States.loading);
        const dto: CompanyParameter = {
          ticketPhysicalSale: mountTicketPhysicalSale(),
          ticketWebsiteSale: mountTicketWebsiteSale(),
          productPhysicalSale: mountProductPhysicalSale(),
          productWebsiteSale: mountProductWebsiteSale(),
        };

        await api.post<void>(`/contractor/${contractor?.id}/fee`, dto);

        toast.success('Taxas configuradas com sucesso!');
        resetFormFee();
        onToggle();
        await handleFetch(currentPage);
      } finally {
        setState(States.default);
      }
    }
  };

  const handleOnSaveTaxes = async (): Promise<void> => {
    if (isFormValidTaxes()) {
      try {
        setState(States.loading);
        const payload: EventProducer = {
          calcAdmFee: formDataTaxes[FormInputTaxes.calcAdmFee] === 'true',
          pdv: Number(unmask(formDataTaxes[FormInputTaxes.pdv])),
          generalCommission: formDataTaxes[FormInputTaxes.generalCommission] === 'true',
          credit: Number(unmask(formDataTaxes[FormInputTaxes.credit])),
          installment: Number(unmask(formDataTaxes[FormInputTaxes.installment])),
          debit: Number(unmask(formDataTaxes[FormInputTaxes.debit])),
          pix: Number(unmask(formDataTaxes[FormInputTaxes.pix])),
          bankslip: Number(unmask(formDataTaxes[FormInputTaxes.bankslip])),
          food: Number(unmask(formDataTaxes[FormInputTaxes.food])),
          technical: Number(unmask(formDataTaxes[FormInputTaxes.technical])),
          trip: Number(unmask(formDataTaxes[FormInputTaxes.trip])),
          rentPos: Number(unmask(formDataTaxes[FormInputTaxes.rentPos])),
          courtesyIssuance: Number(unmask(formDataTaxes[FormInputTaxes.courtesyIssuance])),
          cashSaleDashboard: Number(unmask(formDataTaxes[FormInputTaxes.cashSaleDashboard])),
          ticketCancellations: Number(unmask(formDataTaxes[FormInputTaxes.ticketCancellations])),
          blockMap: Number(unmask(formDataTaxes[FormInputTaxes.blockMap])),
          releaseMap: Number(unmask(formDataTaxes[FormInputTaxes.releaseMap])),
          ticketRoll: Number(unmask(formDataTaxes[FormInputTaxes.ticketRoll])),
          calcAdmFeeProduct: formDataTaxes[FormInputTaxes.calcAdmFeeProduct] === 'true',
          pdvProduct: Number(unmask(formDataTaxes[FormInputTaxes.pdvProduct])),
          generalCommissionProduct:
            formDataTaxes[FormInputTaxes.generalCommissionProduct] === 'true',
          creditProduct: Number(unmask(formDataTaxes[FormInputTaxes.creditProduct])),
          installmentProduct: Number(unmask(formDataTaxes[FormInputTaxes.installmentProduct])),
          debitProduct: Number(unmask(formDataTaxes[FormInputTaxes.debitProduct])),
          pixProduct: Number(unmask(formDataTaxes[FormInputTaxes.pixProduct])),
          bankSlipProduct: Number(unmask(formDataTaxes[FormInputTaxes.bankSlipProduct])),
          foodProduct: Number(unmask(formDataTaxes[FormInputTaxes.foodProduct])),
          technicalProduct: Number(unmask(formDataTaxes[FormInputTaxes.technicalProduct])),
          tripProduct: Number(unmask(formDataTaxes[FormInputTaxes.tripProduct])),
          rentPosProduct: Number(unmask(formDataTaxes[FormInputTaxes.rentPosProduct])),
          courtesyIssuanceProduct: Number(
            unmask(formDataTaxes[FormInputTaxes.courtesyIssuanceProduct]),
          ),
          cashSaleDashboardProduct: Number(
            unmask(formDataTaxes[FormInputTaxes.cashSaleDashboardProduct]),
          ),
          ticketCancellationsProduct: Number(
            unmask(formDataTaxes[FormInputTaxes.ticketCancellationsProduct]),
          ),
          ticketRollProduct: Number(unmask(formDataTaxes[FormInputTaxes.ticketRollProduct])),
        };

        await api.post<void>(`/contractor/${contractor?.id}/taxe`, payload);

        toast.success('Taxas configuradas com sucesso!');
        resetFormTaxes();
        onToggle();
        await handleFetch(currentPage);
      } finally {
        setState(States.default);
      }
    }
  };

  const handleOnShowDeleteContractor = (posSelected: Contractor): void => {
    confirmDelete.show({
      title: '',
      children: <DeleteContent />,
      actions: [
        {
          title: 'Não, quero manter',
          theme: 'noneBorder',
          onClick: (): void => handleOnClose(),
        },
        {
          title: 'Sim, quero excluir',
          onClick: (): Promise<void> => handleOnConfirmDeleteToContractor(posSelected),
        },
      ],
    });
  };

  const handleOnDeleteRowBankAccount = (values: BanckAccountForm): void => {
    listBankAccount.splice(listBankAccount.indexOf(values), 1);
    setListBankAccount([...listBankAccount]);
  };

  const handleOnFilter = async (): Promise<void> => {
    try {
      if (isFormValidFilter()) {
        const payload =
          {
            name: {
              entity: {
                name: formDataFilter[FormInputNameToFilter.inputSearch],
              },
            },
            serialNumber: {
              entity: {
                serialNumber: formDataFilter[FormInputNameToFilter.inputSearch],
              },
            },
          }[formDataFilter[FormInputNameToFilter.filterSearch]] || {};

        onToggle();
        await handleFetch({
          ...currentPage,
          ...payload,
        });
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    }
  };

  const clearFilter = async (): Promise<void> => {
    resetFormFilter();
    await handleFetch({
      ...currentPage,
      entity: {},
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
    onToggle();
  };

  const handleOnPaginationChange = async (page: number): Promise<void> => {
    handleFetch({
      ...currentPage,
      page,
    });
  };

  const handleOnReloadPassword = async (contractorId: string): Promise<void> => {
    try {
      setState(States.loading);
      const response = await api.get(`/contractor/${contractorId}/send-pass`);
      if (response.status === 200) {
        toast.success('Senhas enviada com sucesso!');
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    if (contractor?.id) {
      const statusBooleanString = {
        0: 'true',
        1: 'false',
        2: 'false',
      }[contractor.status];

      onChangeFormInputContractor(FormInputNameToSaveContractor.name)(contractor.name);
      onChangeFormInputContractor(FormInputNameToSaveContractor.document)(contractor.document);
      onChangeFormInputContractor(FormInputNameToSaveContractor.telephone)(contractor.telephone);
      onChangeFormInputContractor(FormInputNameToSaveContractor.email)(contractor.email);

      onChangeFormInputContractor(FormInputNameToSaveContractor.reportPassword)(
        contractor.reportPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.reversePassword)(
        contractor.reversePassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.bleedPassword)(
        contractor.bleedPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.closeCashierPassword)(
        contractor.closeCashierPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.courtesyPassword)(
        contractor.courtesyPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.reprintPassword)(
        contractor.reprintPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.validatorPassword)(
        contractor.validatorPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.pdvReportPassword)(
        contractor.pdvReportPassword,
      );
      onChangeFormInputContractor(FormInputNameToSaveContractor.stockPassword)(
        contractor.stockPassword,
      );

      if (contractor.address) {
        onChangeFormInputContractor(FormInputNameToSaveContractor.zipCode)(
          contractor.address.zipCode,
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.state)(contractor.address.state);
        onChangeFormInputContractor(FormInputNameToSaveContractor.city)(contractor.address.city);
        onChangeFormInputContractor(FormInputNameToSaveContractor.district)(
          contractor.address.district,
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.street)(
          contractor.address.street,
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.number)(
          contractor.address.number ?? '',
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.complement)(
          contractor.address.complement ?? '',
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.latitude)(
          contractor.address.latitude ? String(contractor.address.latitude) : '',
        );
        onChangeFormInputContractor(FormInputNameToSaveContractor.longitude)(
          contractor.address.longitude ? String(contractor.address.longitude) : '',
        );
      }

      resetFormFee();
      if (contractor.ticketPhysicalSale) {
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSaleId)(
          String(contractor.ticketPhysicalSale.id),
        );
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSaleDebit)(
          String(Number(contractor.ticketPhysicalSale.debit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSaleCredit)(
          String(Number(contractor.ticketPhysicalSale.credit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSalePix)(
          String(Number(contractor.ticketPhysicalSale.pix * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSaleAdministrateTax)(
          String(Number(contractor.ticketPhysicalSale.administrateTax * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketPhysicalSaleInstallmentFees)(
          loadInstallmentFees(contractor.ticketPhysicalSale.installmentFees),
        );
      }
      if (contractor.ticketWebsiteSale) {
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSaleId)(
          String(contractor.ticketWebsiteSale.id),
        );
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSaleBankSlip)(
          String(Number(contractor.ticketWebsiteSale.bankSlip * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSaleCredit)(
          String(Number(contractor.ticketWebsiteSale.credit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSalePix)(
          String(Number(contractor.ticketWebsiteSale.pix * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSaleAdministrateTax)(
          String(Number(contractor.ticketWebsiteSale.administrateTax * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.ticketWebsiteSaleInstallmentFees)(
          loadInstallmentFees(contractor.ticketWebsiteSale.installmentFees),
        );
      }
      if (contractor.productPhysicalSale) {
        onChangeFormInputFee(FormInputNameFee.productPhysicalSaleId)(
          String(contractor.productPhysicalSale.id),
        );
        onChangeFormInputFee(FormInputNameFee.productPhysicalSaleDebit)(
          String(Number(contractor.productPhysicalSale.debit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productPhysicalSaleCredit)(
          String(Number(contractor.productPhysicalSale.credit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productPhysicalSalePix)(
          String(Number(contractor.productPhysicalSale.pix * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productPhysicalSaleAdministrateTax)(
          String(Number(contractor.productPhysicalSale.administrateTax * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productPhysicalSaleInstallmentFees)(
          loadInstallmentFees(contractor.productPhysicalSale.installmentFees),
        );
      }
      if (contractor.productWebsiteSale) {
        onChangeFormInputFee(FormInputNameFee.productWebsiteSaleId)(
          String(contractor.productWebsiteSale.id),
        );
        onChangeFormInputFee(FormInputNameFee.productWebsiteSaleBankSlip)(
          String(Number(contractor.productWebsiteSale.bankSlip * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productWebsiteSaleCredit)(
          String(Number(contractor.productWebsiteSale.credit * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productWebsiteSalePix)(
          String(Number(contractor.productWebsiteSale.pix * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productWebsiteSaleAdministrateTax)(
          String(Number(contractor.productWebsiteSale.administrateTax * 100).toFixed(0)),
        );
        onChangeFormInputFee(FormInputNameFee.productWebsiteSaleInstallmentFees)(
          loadInstallmentFees(contractor.productWebsiteSale.installmentFees),
        );
      }

      if (contractor.producerTaxes) {
        onChangeFormInputTaxes(FormInputTaxes.calcAdmFee)(`${contractor.producerTaxes.calcAdmFee}`);
        onChangeFormInputTaxes(FormInputTaxes.pdv)(`${Number(contractor.producerTaxes.pdv) * 100}`);
        onChangeFormInputTaxes(FormInputTaxes.generalCommission)(
          contractor.producerTaxes.generalCommission ? 'true' : 'false',
        );
        onChangeFormInputTaxes(FormInputTaxes.credit)(
          `${Number(contractor.producerTaxes.credit) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.installment)(
          `${Number(contractor.producerTaxes.installment) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.debit)(
          `${Number(contractor.producerTaxes.debit) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.pix)(`${Number(contractor.producerTaxes.pix) * 100}`);
        onChangeFormInputTaxes(FormInputTaxes.bankslip)(`${contractor.producerTaxes.bankslip}`);
        onChangeFormInputTaxes(FormInputTaxes.food)(`${contractor.producerTaxes.food}`);
        onChangeFormInputTaxes(FormInputTaxes.technical)(`${contractor.producerTaxes.technical}`);
        onChangeFormInputTaxes(FormInputTaxes.trip)(`${contractor.producerTaxes.trip}`);
        onChangeFormInputTaxes(FormInputTaxes.rentPos)(`${contractor.producerTaxes.rentPos}`);
        onChangeFormInputTaxes(FormInputTaxes.courtesyIssuance)(
          `${contractor.producerTaxes.courtesyIssuance}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.cashSaleDashboard)(
          `${contractor.producerTaxes.cashSaleDashboard}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.ticketCancellations)(
          `${contractor.producerTaxes.ticketCancellations}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.blockMap)(`${contractor.producerTaxes.blockMap}`);
        onChangeFormInputTaxes(FormInputTaxes.releaseMap)(`${contractor.producerTaxes.releaseMap}`);
        onChangeFormInputTaxes(FormInputTaxes.ticketRoll)(`${contractor.producerTaxes.ticketRoll}`);
        onChangeFormInputTaxes(FormInputTaxes.calcAdmFeeProduct)(
          `${contractor.producerTaxes.calcAdmFeeProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.pdvProduct)(
          `${Number(contractor.producerTaxes.pdvProduct) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.generalCommissionProduct)(
          contractor.producerTaxes.generalCommissionProduct ? 'true' : 'false',
        );
        onChangeFormInputTaxes(FormInputTaxes.creditProduct)(
          `${Number(contractor.producerTaxes.creditProduct) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.installmentProduct)(
          `${Number(contractor.producerTaxes.installmentProduct) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.debitProduct)(
          `${Number(contractor.producerTaxes.debitProduct) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.pixProduct)(
          `${Number(contractor.producerTaxes.pixProduct) * 100}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.bankSlipProduct)(
          `${contractor.producerTaxes.bankSlipProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.foodProduct)(
          `${contractor.producerTaxes.foodProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.technicalProduct)(
          `${contractor.producerTaxes.technicalProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.tripProduct)(
          `${contractor.producerTaxes.tripProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.rentPosProduct)(
          `${contractor.producerTaxes.rentPosProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.courtesyIssuanceProduct)(
          `${contractor.producerTaxes.courtesyIssuanceProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.cashSaleDashboardProduct)(
          `${contractor.producerTaxes.cashSaleDashboardProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.ticketCancellationsProduct)(
          `${contractor.producerTaxes.ticketCancellationsProduct}`,
        );
        onChangeFormInputTaxes(FormInputTaxes.ticketRollProduct)(
          `${contractor.producerTaxes.ticketRollProduct}`,
        );
      } else {
        resetFormTaxes();
      }

      onChangeFormInputContractor(FormInputNameToSaveContractor.status)(statusBooleanString);

      setListBankAccount(
        contractor.bankAccount.map(item => ({
          id: item.bank.id,
          name: item.bank.fullName,
          agencia: item.agency,
          conta: `${item.account}-${item.digit}`,
        })),
      );

      setPixs(contractor.pixKey);
      setUsersSelected(contractor.users);
      setListUsers(user =>
        // remove users that are already selected
        user.filter(
          userItem => !contractor.users.find(userSelected => userSelected.id === userItem.id),
        ),
      );
    }
  }, [contractor]);

  useEffect(() => {
    handleFetch(currentPage);
    handleGetbankAccount();
    handleGetUsers();
  }, []);

  return (
    <ContractorContainer
      state={state}
      contractorState={contractor}
      title={title}
      visible={visible}
      onToggle={onToggle}
      onPaginationChange={handleOnPaginationChange}
      shouldShowModal={shouldShowModal}
      onSaveContractor={handleOnSaveContractor}
      onSaveBankAccount={handleOnBankAccount}
      onSavePix={handleOnPix}
      listContractor={listContractor}
      currentPage={currentPage}
      changeColorColumn={handleOnChangeColorColumn}
      onChangeFormInputFilter={onChangeFormInputFilter}
      onShouldShowModal={handleOnShouldShowModal}
      formDataContractor={formDataContractor}
      formErrorsContractor={formErrorsContractor}
      toggleReportPassword={toggleReportPassword}
      toggleReversePassword={toggleReversePassword}
      toggleBleedPassword={toggleBleedPassword}
      toggleCloseCashierPassword={toggleCloseCashierPassword}
      toggleCourtesyPassword={toggleCourtesyPassword}
      toggleReprintPassword={toggleReprintPassword}
      toggleValidatorPassword={toggleValidatorPassword}
      togglePdvReportPassword={togglePdvReportPassword}
      toggleStockPassword={toggleStockPassword}
      onChangeFormInputContractor={onChangeFormInputContractor}
      setToggleReportPassword={setToggleReportPassword}
      setToggleReversePassword={setToggleReversePassword}
      setToggleBleedPassword={setToggleBleedPassword}
      setToggleCloseCashierPassword={setToggleCloseCashierPassword}
      setToggleCourtesyPassword={setToggleCourtesyPassword}
      setToggleReprintPassword={setToggleReprintPassword}
      setToggleValidatorPassword={setToggleValidatorPassword}
      setTogglePdvReportPassword={setTogglePdvReportPassword}
      setToggleStockPassword={setToggleStockPassword}
      banks={banks}
      formDataPix={formDataPix}
      formErrorsPix={formErrorsPix}
      onChangeFormInputPix={onChangeFormInputPix}
      formDataFee={formDataFee}
      formErrorsFee={formErrorsFee}
      onChangeFormInputFee={onChangeFormInputFee}
      onSaveFee={handleOnSaveFee}
      formDataTaxes={formDataTaxes}
      formErrorsTaxes={formErrorsTaxes}
      onChangeFormInputTaxes={onChangeFormInputTaxes}
      onSaveTaxes={handleOnSaveTaxes}
      formDataFilter={formDataFilter}
      formErrorsFilter={formErrorsFilter}
      onShowDeleteContractor={handleOnShowDeleteContractor}
      onFilter={handleOnFilter}
      listBankAccount={listBankAccount}
      pixs={pixs}
      clearFilter={clearFilter}
      controllerInputAppendBankAccount={controllerInputAppendBankAccount}
      controllerAppendUser={controllerAppendUser}
      onDeleteRowBankAccount={handleOnDeleteRowBankAccount}
      onDeletePix={handleOnRemovePix}
      // listContractorType={listContractorType}
      onReloadPassword={handleOnReloadPassword}
    />
  );
};
